'use client';

import { useClearRefinements, useSearchBox } from 'react-instantsearch';

export default function JobClearFilters() {
  const { canRefine, refine: clearRefinements } = useClearRefinements();
  const { query, clear: clearQuery } = useSearchBox();
  const active = canRefine || query.length > 0;

  const handleReset = () => {
    clearRefinements();
    clearQuery();
  };

  return (
    <button
      type="button"
      onClick={handleReset}
      disabled={!active}
      aria-label="Réinitialiser les filtres"
      title="Réinitialiser les filtres"
      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full border transition ${
        active
          ? 'border-zinc-200 text-zinc-700 hover:bg-zinc-100'
          : 'cursor-not-allowed border-zinc-100 text-zinc-300'
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}
